/* This example requires Tailwind CSS v2.0+ */
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";
import LinkWrapper from "@/components/linkWrapper";

export const query = graphql`
  fragment LogoCloudOffWhiteGridData on StrapiComponentLogoCloudOffWhiteGrid {
    title
    topic
    logos {
      ...StrapiSharedLink
    }
  }
`;

function OffWhiteGrid({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        {data.topic && (
          <MarkdownWrapper
            text={data.topic}
            markdownClassName="leading-6 text-center text-text-secondary font-semibold tracking-wide uppercase"
          />
        )}
        {data.title && (
          <h3 className="text-center text-base font-semibold uppercase tracking-wider text-text-secondary">
            <MarkdownWrapper text={data.title} />
          </h3>
        )}
        {Boolean(data.logos?.length) && (
          <div className="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-8">
            {data.logos.map(
              (logo, index) =>
                (logo.overwriteIcon || logo.link?.icon) && (
                  <div
                    key={index}
                    className="col-span-1 flex justify-center bg-background-off-white px-4 py-6"
                  >
                    <LinkWrapper
                      to={logo?.link?.url}
                      className={`px-4 py-2 ${
                        logo?.link?.url
                          ? "rounded-md hover:bg-background-light-gray"
                          : ""
                      }`}
                    >
                      <MediaWrapper
                        media={logo.overwriteIcon || logo.link.icon}
                        divClassName="h-12"
                        objectFit="contain"
                      />
                    </LinkWrapper>
                  </div>
                )
            )}
          </div>
        )}
      </div>
    </div>
  );
}

OffWhiteGrid.propTypes = {
  data: PropTypes.object,
};

export default OffWhiteGrid;
